import React from "react";

import {cn} from "lib/utils";

/**
 * The subject rail under the masthead.
 *
 * Pills read as app chrome; a newspaper separates its subjects with rules and
 * sets them in small caps. The active subject is marked by the masthead colour
 * and an underscore rule, the same device the section nav uses, so the two
 * navigation layers feel like one system.
 */
const FilterBar = ({categories, selectedCategory, onSelectCategory}) => {
  const options = ["", ...categories];

  return (
    <div className="border-b border-rule bg-paper">
      <div className="container">
        <div
          className="-mx-1 flex items-center gap-0.5 overflow-x-auto py-1.5 [scrollbar-width:none] [&::-webkit-scrollbar]:hidden"
          role="tablist"
          aria-label="Filter stories by subject"
        >
          {options.map((category) => {
            const active = selectedCategory === category;
            return (
              <button
                key={category || "all"}
                type="button"
                role="tab"
                aria-selected={active}
                onClick={() => onSelectCategory(category)}
                className={cn(
                  "whitespace-nowrap border-b-2 px-3 py-1.5 font-sans text-meta font-semibold uppercase tracking-[0.08em]",
                  "transition-colors duration-150 ease-out",
                  "focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-ring",
                  active
                    ? "border-masthead text-masthead"
                    : "border-transparent text-ink-tertiary hover:text-ink"
                )}
              >
                {category || "All"}
              </button>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default FilterBar;
